module.exports = __webpack_public_path__ + "static/img/Dungeon & Fighter Mobile.a502781f.png";